<script lang="ts" setup>
import AppButton from "~/components/ui/buttons/AppButton.vue"
import AppLink from "~/components/ui/links/AppLink.vue";
import useSearchStore from "~/shared/store/modules/search";
import type { IProductInfo } from "~/shared/interfaces/search/product";
import getNumberWithSpaces from "~/composables/number-formatter";

const props = defineProps<{
  paddingTop?: string
  product: IProductInfo
  minPrice: number | null
}>()

const searchStore = useSearchStore()
let price: string

if (props.minPrice) {
  price = getNumberWithSpaces(props.minPrice)
}

</script>

<template>
  <div class="product-buy">
    <div class="product-buy__container">
      <div class="product-buy__price" v-if="minPrice">
        <span>от</span>
        <span>{{ price }}&nbsp;₽</span>
      </div>
      <div class="product-buy__not-available" v-else>
        Нет в наличии
      </div>
      <AppButton v-if="minPrice" class="product-buy__btn" text="Купить в один клик" size="l"
        @click="searchStore.setOneClickModalState(true)" />
      <AppButton v-else type="secondary" class="product-buy__btn" text="Сообщить о поступлении" size="l"
        @click="searchStore.setRememberMeModalState(true)" />
    </div>
    <AppLink v-if="minPrice" class="product-buy__anchor" text="Цены и наличие" url="#productTable" :is-anchor="true"
      :is-nuxt-link="false" :font-weight="500" />
  </div>
</template>

<style lang="scss" scoped>
.product-buy {
  padding-top: v-bind(paddingTop);
  width: 306px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;

  @include md-breakpoint {
    padding-top: 0;
    width: 100%;
    gap: 24px;
  }

  &__container {
    width: 100%;
    box-shadow: 0 4px 24px 0 #0000001F;
    border-radius: 20px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__anchor {
    @include md-breakpoint {
      width: calc(100% - 48px);
    }
  }

  &__price {
    display: flex;
    gap: 6px;
    align-items: flex-end;

    span {
      &:first-child {
        @include font(18px, 26px, 600);
      }

      &:last-child {
        @include font(28px, 32px, 600);
      }
    }
  }

  &__btn {
    width: 100%;
  }

  &__not-available {
    @include font(24px, 28px, 600);
    color: $content_secondary;
    @include md-breakpoint {
      @include font(20px, 24px, 600);
    }
  }
}
</style>
